import { loadScript, isIE } from '.';
import { imagesBaseUrl } from '../constants';

const pColor = '#436BFF';
const d9Color = '#D9D9D9';
// const _8cColor = '#8C8C8C'
const e9Color = '#E9E9E9';
const wColor = '#fff';
const cColor = '#CCCCCC';
const bColor = '#BFBFBF';
const _80Color = '#808080';

const addPath = 'M0 -4.5L0 4.5M-4.5 0L4.5 0z';
const crossPath = 'M0 -8L0 8M-8 0L8 0z';
const fontFamily = '-apple-system,"PingFang SC","Helvetica Neue",STHeiti,"Microsoft Yahei",Tahoma,Simsun,sans-serif';

const labelWidth = (localStorage.getItem('yxtLang') === 'zh' || localStorage.getItem('yxtLang') === 'ha') ? 162 : 235;
const iconWidth = (localStorage.getItem('yxtLang') === 'zh' || localStorage.getItem('yxtLang') === 'ha') ? 100 : 120;

function createTextEll({ text, color, fontWeight, lineHeight }) {
  const attr = {
    'pointer-events': 'none',
    'font-weight': fontWeight,
    'line-height': `${lineHeight || 20}px`,
    color
  };
  let style = '';
  Object.entries(attr).forEach(([key, value]) => {
    if (value) {
      style += `${key}:${value};`;
    }
  });
  return `<div class="ell" style="${style}">${text}</div>`;
}

function compatibleConfig() {
  if (isIE()) {
    return {
      renderer: 'canvas',
      // renderer: 'svg',
      createTxt(group, attrs, id) {
        if (attrs.y) {
          attrs.y += 15;
        }
        const shape = group.addShape('text', {
          attrs,
          id
        });
        return shape;
      },
      changeNodeTxt(node, text) {
        node.attr({
          text
        });
      }
    };
  }

  return {
    renderer: 'svg',
    createTxt(group, attrs, id) {
      const { fill, text, x, y, width, height, ...others } = attrs;
      const html = createTextEll({ text, color: fill, ...others });
      return group.addShape('dom', {
        attrs: {
          width,
          height,
          x,
          y,
          text,
          html
        },
        id
      });
    },
    changeNodeTxt(node, text) {
      const {html} = node.attrs;
      const lastEnd = html.lastIndexOf('</');
      const lIndex = html.substr(0, lastEnd).lastIndexOf('>');

      node.attr({
        html: html.substr(0, lIndex + 1) + text + html.substr(lastEnd),
        text
      });
    }
  };
}

const customConfig = compatibleConfig();

function createAdd(group, attrs) {
  const g = group.addGroup({
    name: 'event-add-node',
    attrs: {
      matrix: [1, 0, 0, 0, 1, 0, attrs.x, attrs.y, 1]
    }
  });
  g.addShape('circle', {
    attrs: {
      x: 0,
      y: 0,
      r: 9,
      fill: wColor,
      stroke: pColor,
      lineWidth: 2
    },
    id: 'add-bg'
  });
  g.addShape('path', {
    attrs: {
      stroke: pColor,
      lineWidth: 2,
      cursor: 'pointer',
      path: addPath
    },
    id: 'add-icon'
  });
  g.addShape('circle', {
    attrs: {
      x: 0,
      y: 0,
      r: 9,
      fill: 'transparent',
      cursor: 'pointer'
    },
    zIndex: 2
  });
}

export async function registerAuditCard(opts) {
  const { nodeOptions, nodeOptionsMap, lang } = opts;
  let graph = null;
  const getTextByOptionId = (value) => {
    switch (value) {
      case 0:
      case 1:
        return nodeOptionsMap[value];
      case 2:
      case 3:
        return '';
      case 4:
        return nodeOptionsMap[4];
    }
  };
  const initAuditConfig = {
    renderer: customConfig.renderer, // 使用 Dom node 的时候需要使用 svg 的渲染形势
    fitViewPadding: 100,
    fitCenter: true,
    maxZoom: 2,
    minZoom: 0.5,
    modes: {
      default: ['zoom-canvas', 'drag-canvas', 'card-audit-event']
    },
    layout: {
      type: 'bigraph-layout',
      nodeSep: 50, // 同一部分的节点间距
      direction: 'vertical' // {vertical,horizontal} 两部分的分布方向
    },
    plugins: [],
    defaultNode: {
      type: 'cardAudit',
      size: [164, 80],
      style: {
        fill: '#fff',
        stroke: '#E6EEFF'
      },
      labelCfg: {
        position: 'left'
      },
      options: nodeOptions
    },
    defaultEdge: {
      type: 'edgeAuditAdd',
      style: {
        stroke: pColor,
        lineWidth: 2
      }
    },
    nodeStateStyles: {
      hover: {
        shadowColor: 'rgba(30, 103, 225, 0.08)',
        shadowBlur: 9,
        shadowOffsetX: 4,
        shadowOffsetY: 4,
        lineWidth: 2,
        stroke: '#436BFF'
      },
      selected: {
        shadowColor: 'rgba(30, 103, 225, 0.08)',
        shadowBlur: 9,
        shadowOffsetX: 4,
        shadowOffsetY: 4,
        lineWidth: 2,
        stroke: '#436BFF'
      }
    },
    // 边不同状态下的样式集合
    edgeStateStyles: {
    // 鼠标点击边，即 click 状态为 true 时的样式
      click: {}
    }
  };
  await loadScript(`${imagesBaseUrl}npm/antv/g6/4.6.4/dist/g6.min.js`);
  const {G6} = window;
  /**
   * 自定义节点
   */
  G6.registerNode('shapeClass', {
    options: {
      _attrs: {
        paddingLeft: 16,
        paddingTop: 16,
        colors: {
          primary: '#6B90FF',
          gray5: '#D9D9D9',
          gray9: '#595959',
          pHover: '#F7FAFF'
        },
        shadowColor: 'rgba(30, 103, 225, 0.08)',
        shadowBlur: 9,
        shadowOffsetX: 4,
        shadowOffsetY: 4
      }
    },
    createRectCard(group, attrs) {
      const main = group.addShape('rect', {
        attrs: {
          ...attrs,
          lineWidth: 1,
          radius: [4, 4, 4, 4]
        },
        name: 'card-rect'
      });
      return main;
    },
    createCheckboxRadio(group, attrs, auditPersType, optType) {
      const { colors, paddingLeft, paddingTop } = this.options._attrs;
      const width = labelWidth;
      const height = 46;
      const hc = height / 2;
      const g = group.addGroup({
        attrs: {
          matrix: [1, 0, 0, 0, 1, 0, paddingLeft, paddingTop, 1]
        },
        name: 'checkbox-radio',
        auditPersType,
        optType
      });
      g.addShape('rect', {
        attrs: {
          width,
          height,
          fill: 'white',
          cursor: 'pointer'
        },
        id: 'radio-bg'
      });
      let stroke = colors.gray5;
      let lineWidth = 1; let r = 8;
      if (attrs.selected) {
        stroke = colors.primary;
        lineWidth = 5;
        r = 6;
      }
      g.addShape('circle', {
        attrs: {
          x: 16 + 8,
          y: hc,
          r,
          stroke,
          lineWidth,
          cursor: 'pointer'
        },
        id: 'radio-icon'
      });
      let text = attrs.label;
      // if (auditPersType === 2 && text.length >= 6) {
      //   // '沙发斯蒂斯蒂芬'.charCodeAt(0).toString(16) toUnicode
      //   text = text.substring(0, 8) + '...';
      // }
      g.addShape('text', {
        attrs: {
          x: 16 + 16 + 8,
          matrix: [1, 0, 0, 0, 1, 0, 0, 15, 1],
          fontSize: 14,
          text,
          fill: colors.gray9,
          textBaseline: 'top',
          cursor: 'pointer'
        }
      });
      if (attrs.help) {
        const g2 = g.addGroup({
          attrs: {
            matrix: [1, 0, 0, 0, 1, 0, iconWidth, hc - (12 / 2), 1],
            help: attrs.help
          },
          name: 'event-help-icon'
        });
        g2.addShape('path', {
          attrs: {
            fill: colors.gray5,
            path: 'M8,2 C11.3137085,2 14,4.6862915 14,8 C14,11.3137085 11.3137085,14 8,14 C4.6862915,14 2,11.3137085 2,8 C2,4.6862915 4.6862915,2 8,2 Z M8,3 C5.23857625,3 3,5.23857625 3,8 C3,10.7614237 5.23857625,13 8,13 C10.7614237,13 13,10.7614237 13,8 C13,5.23857625 10.7614237,3 8,3 Z M7.99,10.5 C8.2,10.5 8.38,10.56 8.52,10.7 C8.66,10.83 8.73,11 8.73,11.21 C8.73,11.42 8.65,11.59 8.51,11.73 C8.37,11.86 8.19,11.93 7.99,11.93 C7.79,11.93 7.61,11.86 7.47,11.72 C7.33,11.58 7.26,11.41 7.26,11.21 C7.26,11 7.33,10.83 7.47,10.7 C7.61,10.56 7.79,10.5 7.99,10.5 Z M8.17,4.4 C8.81,4.4 9.33,4.57 9.73,4.93 C10.13,5.28 10.33,5.76 10.33,6.36 C10.33,6.85 10.2,7.26 9.95,7.58 C9.86,7.69 9.58,7.95 9.11,8.36 C8.92,8.52 8.78,8.7 8.69,8.88 C8.58,9.08 8.53,9.3 8.53,9.54 L8.53,9.54 L8.529,9.624 L8.53,9.635 C8.53,9.6387793 8.52996081,9.64254944 8.52988282,9.64631005 L8.53,9.71 C8.48836475,9.96991992 8.26504798,10.17 7.995,10.17 C7.69952766,10.17 7.46,9.93047234 7.46,9.635 L7.466,9.709 L7.46,9.71 L7.46,9.54 C7.46,9.17 7.52,8.85 7.66,8.59 C7.79,8.31 8.17,7.9 8.79,7.35 L8.79,7.35 L8.96,7.16 C9.14,6.93 9.24,6.69 9.24,6.43 C9.24,6.08 9.14,5.81 8.95,5.61 C8.75,5.41 8.46,5.31 8.1,5.31 C7.65,5.31 7.32,5.45 7.12,5.74 C6.94,5.98 6.85,6.32 6.85,6.76 L6.85,6.76 C6.80834064,7.01437779 6.58951533,7.21 6.325,7.21 C6.03505051,7.21 5.8,6.97494949 5.8,6.685 L5.806,6.759 C5.8,6.7408972 5.8001438,6.72190396 5.80043141,6.7030201 L5.8,6.685 C5.8,6.67163353 5.80049952,6.65838374 5.8014809,6.64526826 C5.82296977,5.9696967 6.03237383,5.43762617 6.43,5.04 C6.85,4.61 7.43,4.4 8.17,4.4 Z'
          },
          capture: false,
          id: 'help-icon'
        });
        g2.addShape('rect', {
          attrs: {
            x: 2,
            y: 2,
            height: 12,
            width: 12,
            help: attrs.help,
            cursor: 'pointer',
            fill: 'transparent'
          },
          zIndex: 2
        });
      }
      if (optType === 'openLayer') {
        g.addShape('path', {
          attrs: {
            matrix: [1, 0, 0, 0, 1, 0, width - paddingLeft - 12, hc - 12 / 2 - 3, 1],
            fill: colors.gray5,
            cursor: 'pointer',
            path: 'M5.166 3.13A.49.49 0 005 3.484c0 .13.055.243.166.34L10.91 9l-5.745 5.175a.44.44 0 00-.166.34c0 .13.055.242.166.34.11.096.24.145.386.145a.61.61 0 00.387-.13l6.095-5.514A.456.456 0 0012.2 9a.456.456 0 00-.166-.356L5.94 3.13A.61.61 0 005.552 3a.61.61 0 00-.386.13z'
          },
          name: 'event-open-selector'
        });
      }
      // if (auditPersType === 3) {
      //   g.get('children').forEach(it => {
      //     it.attr('cursor', 'not-allowed')
      //     it.attr('opacity', 0.6)
      //   })
      // }
      return g;
    },
    createCheckboxRadioList(group, list) {
      const x = 0; let y = 8;
      list.forEach((it, i) => {
        const { value, optType, ...others } = it;
        const g = this.createCheckboxRadio(group, {
          ...others,
          x,
          y
        }, value, optType);
        g.attr('matrix', [1, 0, 0, 0, 1, 0, x, y, 1]);
        if (i === 1) {
          group.addShape('path', {
            attrs: {
              path: [
                ['M', x + 10, y + 46 + 4],
                ['L', labelWidth - 10, y + 46 + 4]
              ],
              stroke: e9Color,
              lineWidth: 1
            }
          });
          y += 9;
        }
        y += 46;
      });
      return { y };
    },
    createCardTitle(group, attrs) {
      return customConfig.createTxt(
        group,
        {
          ...attrs,
          fontSize: 14,
          fontWeight: 'bold'
        },
        'title'
      );
    },
    createCardBody(group, attrs) {
      const { fill = '#8C8C8C' } = attrs;
      return customConfig.createTxt(
        group,
        {
          ...attrs,
          fontSize: 12,
          fill
        },
        'label'
      );
    }
  });
  G6.registerNode('menuAudit', {
    draw(cfg, group) {
      const { attr, options, optionRoles = [] } = cfg;
      group.attr('matrix', [1, 0, 0, 0, 1, 0, attr.x, attr.y, 1]);
      console.debug('options', options);
      const c = group.addShape('rect', {
        attrs: {
          ...this.cardShadowStyle,
          width: labelWidth,
          fill: wColor,
          zIndex: 100
        }
      });
      options.some(it => {
        if (it.value === 2) {
          it.help = optionRoles.length > 0 ? optionRoles.map(it => `${it.roleName}: ${it.roleDesc}`).join('<br/>') : opts.lang.pcTipNoAuditRole;
          return true;
        }
        return false;
      });
      const { y } = this.createCheckboxRadioList(group, options);
      console.debug('yyy:', y);
      c.attr('height', y + 8);
      return c;
    }
  }, 'shapeClass');
  // 80 - 4 = 76; 22 + 16 = 38; 76 - 38 = 42
  G6.registerNode('cardBase', {
    draw(cfg, group) {
      const { style, size } = cfg;
      const offsetX = -size[0] / 2;
      const offsetY = -size[1] / 2;
      return this.createRectCard(group, {
        x: offsetX,
        y: offsetY,
        width: size[0],
        height: size[1],
        stroke: style.stroke,
        fill: style.fill
      });
    },
    setState(name, value, item) {
      const { selected } = item.getModel();
      const group = item.getContainer();
      const shape = group.get('children')[0];
      switch (name) {
        case 'hover':
          if (value === true) {
            shape.attr(item.getStateStyle('selected'));
            break;
          }
          if (!selected) {
            shape.attr({
              shadowColor: 'transparent',
              lineWidth: 1,
              stroke: '#E6EEFF'
            });
          }
          break;
      }
    }
  }, 'shapeClass');
  // TODO labCfg 布局 横纵
  G6.registerNode('cardAuditEnd', {
    options: {
      txtStyle: {
        text: lang.txtEnd,
        fill: pColor
      },
      style: {
        fill: '#E6EEFF',
        stroke: pColor
      }
    },
    draw(cfg, group) {
      const { size } = cfg;
      const { style, txtStyle } = this.options;
      const offsetX = -size[0] / 2;
      const container = group.addShape('rect', {
        attrs: {
          x: offsetX,
          width: size[0],
          height: size[1],
          stroke: style.stroke,
          lineWidth: 1,
          fill: style.fill,
          radius: [4, 4, 4, 4]
        }
      });
      group.addShape('text', {
        attrs: {
          x: offsetX + size[0] / 2,
          lineHeight: `${20}px`,
          fontSize: 14,
          fill: txtStyle.fill,
          text: txtStyle.text,
          fontFamily,
          fontWeight: 'bold',
          textAlign: 'center',
          textBaseline: 'top',
          matrix: [1, 0, 0, 0, 1, 0, 0, 14 / 2 + 1, 1]
        }
      });
      return container;
    }
  });

  G6.registerNode('cardAuditStart',
    {
      options: {
        placeholder: lang.txtSetTip,
        btnTxt: lang.txtSet,
        btnColor: '#436BFF',
        title: lang.setup,
        titleFill: '#262626',
        labelFill: '#8C8C8C'
      },
      draw(cfg, group) {
        const { style, size } = cfg;
        const offsetX = -size[0] / 2;
        const offsetY = -size[1] / 2;
        const container = this.createRectCard(group, {
          x: offsetX,
          y: offsetY,
          width: size[0],
          height: size[1],
          stroke: style.stroke,
          fill: style.fill
        });
        return container;
      },
      afterDraw(cfg, group) {
        const opt = this.options;
        const { label, size } = cfg;
        const offsetX = -size[0] / 2;
        const offsetY = -size[1] / 2;
        const titleH = 20;
        this.createCardTitle(group, {
          width: 48,
          height: titleH,
          lineHeight: titleH,
          x: offsetX + 16,
          y: offsetY + 16,
          text: opt.title,
          fill: opt.titleFill
        });
        // 设置
        group.addShape('text', {
          attrs: {
            x: offsetX + 16 + 10 + 48,
            y: offsetY + 16,
            lineHeight: '20px',
            fontSize: 14,
            text: opt.btnTxt,
            fill: opt.btnColor,
            fontFamily,
            cursor: 'pointer',
            textAlign: 'start',
            textBaseline: 'top'
          },
          name: 'event-set-node'
        });
        this.createCardBody(group, {
          height: size[1] - titleH - 16 * 2,
          width: size[0] - 16 * 2,
          x: offsetX + 16,
          y: offsetY + 16 + titleH + 8,
          text: label || opt.placeholder,
          fill: opt.labelFill
        });
      }
    },
    'shapeClass'
  );

  G6.registerNode('cardAudit',
    {
      options: {
        style: {
          fill: '#E6EEFF',
          cFill: '#D9D9D9'
        },
        stateStyles: {
          hover: {
            cFill: '#8C8C8C'
          }
        },
        titleFill: '#262626',
        labelFill: '#8C8C8C',
        placeholderTitle: lang.holderSelectRole,
        placeholder: lang.holderSelectFlowRole
      },
      afterDraw(cfg, group) {
        const opt = this.options;
        const { auditPersType, size, appters, roleList } = cfg;
        const offsetX = -size[0] / 2;
        const offsetY = -size[1] / 2;
        const titleH22 = 22;

        let text;
        let txtDefault;

        if (auditPersType < 2) {
          text = lang.txtAudit;
        } else {
          text = nodeOptionsMap[auditPersType];
        }
        if (auditPersType === 2) {
          txtDefault = this.getLabelByArry(
            roleList,
            getTextByOptionId(auditPersType) || opt.placeholderTitle
          );
        } else {
          txtDefault = this.getLabelByArry(
            appters,
            getTextByOptionId(auditPersType) || opt.placeholderTitle
          );
        }
        this.createCardTitle(group, {
          width: size[0] - 16 * 2,
          height: titleH22,
          lineHeight: titleH22,
          x: offsetX + 16,
          y: offsetY + 16,
          text: text || opt.placeholderTitle,
          fill: opt.titleFill
        });
        const bHeight = size[1] - titleH22 - 16 * 2;
        const bWidth = 164 - 16 - 16;
        this.createCardBody(group, {
          height: bHeight,
          width: bWidth,
          x: offsetX + 16,
          y: offsetY + 16 + titleH22 + 8,
          text: txtDefault || cfg.label || opt.placeholder,
          fill: opt.labelFill
        });
      },
      update(cfg, node) {
        const opt = this.options;
        const { selected, options, auditPersType, label, size, optionRoles, appters, roleList, id } = cfg;
        const group = node.getContainer();
        const shape = group.get('children')[0];
        const titleN = group.findById('title');
        const labelN = group.findById('label');
        let subtitle;
        let txtDefault;
        if (auditPersType >= 0) {
          subtitle = lang.txtAudit;
        }

        if (auditPersType === 2) {
          txtDefault = this.getLabelByArry(
            roleList,
            getTextByOptionId(auditPersType) || opt.placeholderTitle
          );
        } else {
          txtDefault = this.getLabelByArry(
            appters,
            getTextByOptionId(auditPersType) || opt.placeholderTitle
          );
        }

        if (subtitle) {
          customConfig.changeNodeTxt(titleN, subtitle);
          const ltext = txtDefault || label || opt.placeholder;
          customConfig.changeNodeTxt(labelN, ltext);
        }
        if (selected === true) {
          shape.attr(node.getStateStyle('selected'));
          const matrix = node.getContainer().getMatrix();
          const { auditPersType } = node.getModel();
          this.showOptions(options, {
            auditPersType,
            optionRoles,
            x: size[0] / 2 + 4,
            y: matrix[7] - size[1] / 2,
            id
          });
        } else {
          shape.attr({
            shadowColor: 'transparent',
            lineWidth: 1,
            stroke: '#E6EEFF'
          });
        }
      },
      showOptions(options, { auditPersType, x, y, id, optionRoles }) {
        options.forEach(it => {
          it.selected = it.value === auditPersType;
        });
        const cur = graph.findById('menu-audit-box');
        if (cur) {
          graph.removeItem(cur);
        }
        graph.addItem('node', {
          type: 'menuAudit',
          id: 'menu-audit-box',
          attr: {
            x, y
          },
          options,
          nodeId: id,
          optionRoles
        });
      },
      getLabelByArry(arry, defTxt) {
        if (arry && arry.length > 0) {
          arry = arry.filter(it => (it.fullName || it.fullname || it.roleName));
          // hack
          const arr = arry.map(it => (it.fullName || it.fullname || it.roleName));
          const str = arr.join(',');
          if (str.indexOf('$') === 0 && str.lastIndexOf('$') === (str.length - 1)) {
            return opts.lang.pcSelectN(arry.length);
          } if (str.length >= 10) {
            return `${str.substr(0, 8)}${lang.tipAndSoOn(arr.length)}`;
          }
          return str;
        }
        return defTxt;
      }
    },
    'cardBase'
  );

  G6.registerEdge('edgeAuditAdd',
    {
      options: {
        style: {
          cStroke: pColor,
          cFill: pColor
        }
      },
      afterDraw(cfg, group) {
        // 获取图形组中的第一个图形，在这里就是边的路径图形
        const shape = group.getChildByIndex(0);
        const quatile = shape.getPoint(0.5);
        if (quatile) {
          createAdd(group, {
            x: quatile.x,
            y: quatile.y
          });
        }
      },
      update: undefined
    },
    'line'
  );

  G6.registerBehavior('card-audit-event', {
    currentMMoveShapName: null,
    getEvents() {
      return {
        'click': 'onClick',
        'node:mouseenter': 'onNodeMouseenter',
        'node:mouseleave': 'onNodeMouseleave',
        'node:click': 'onCardAuditClick',

        'event-remove-node:mouseover': 'onRemoveMouseover',
        'event-remove-node:mouseout': 'onRemoveMouseout',

        'event-add-node:mouseover': 'onAddMouseover',
        'event-add-node:mouseout': 'onAddMouseout',

        'checkbox-radio:click': 'onInputRadioClick',
        'checkbox-radio:mouseover': 'onInputRadioMouseover',
        'checkbox-radio:mouseout': 'onInputRadioMouseout',
        'event-help-icon:mouseover': 'onHelpMouseover',
        'event-help-icon:mouseout': 'onHelpMouseout'
      };
    },
    shouldBegin() {
      // 这里可以根据业务自定义
      return true;
    },
    onClick(e) {
      const {item} = e;
      const type = item && item.get('model').type;
      if (!type || !['menuAudit', 'cardAudit'].includes(type)) {
        e.currentTarget.emit('nodeselectchange', {
          select: false
        });
      }
    },
    onCardAuditClick(e) {
      const m = e.item.get('model');
      if (m.type === 'cardAudit') {
        e.currentTarget.emit('nodeselectchange', {
          select: !m.selected,
          id: m.id
        });
      }
    },
    createCloseBtn(group, attrs) {
      const cbtn = group.findById('id-remove-node');
      if (cbtn) return;
      const g = group.addGroup({
        attrs: {
          cursor: 'pointer',
          matrix: [1, 0, 0, 0, 1, 0, attrs.x - 16 - 5, attrs.y + 5, 1]
        },
        name: 'event-remove-node',
        id: 'id-remove-node'
      });
      g.addShape('marker', {
        attrs: {
          matrix: [1, 0, 0, 0, 1, 0, 1, 1, 1],
          fill: d9Color,
          symbol: () => 'M7,0 C10.8659932,0 14,3.13400675 14,7 C14,10.8659932 10.8659932,14 7,14 C3.13400675,14 0,10.8659932 0,7 C0,3.13400675 3.13400675,0 7,0 Z M5.33770872,4.22951453 C5.03168934,3.92349516 4.53553391,3.92349516 4.22951453,4.22951453 C3.92349516,4.53553391 3.92349516,5.03168934 4.22951453,5.33770872 L4.22951453,5.33770872 L5.892,7 L4.22951453,8.66229128 C3.92349516,8.96831066 3.92349516,9.46446609 4.22951453,9.77048547 C4.53553391,10.0765048 5.03168934,10.0765048 5.33770872,9.77048547 L5.33770872,9.77048547 L7,8.108 L8.66229128,9.77048547 C8.96831066,10.0765048 9.46446609,10.0765048 9.77048547,9.77048547 C10.0765048,9.46446609 10.0765048,8.96831066 9.77048547,8.66229128 L9.77048547,8.66229128 L8.108,7 L9.77048547,5.33770872 C10.0765048,5.03168934 10.0765048,4.53553391 9.77048547,4.22951453 C9.46446609,3.92349516 8.96831066,3.92349516 8.66229128,4.22951453 L8.66229128,4.22951453 L7,5.892 Z'
        },
        id: 'remove-icon'
      });
      g.addShape('rect', {
        attrs: {
          height: 16,
          width: 16,
          cursor: 'pointer',
          fill: 'transparent'
        },
        zIndex: 2
      });
    },
    deleteCloseBtn(group) {
      const cbtn = group.findById('id-remove-node');
      cbtn && group.removeChild(cbtn);
    },
    onNodeMouseenter(e) {
      // console.debug('onNodeMouseenter', e)
      e.preventDefault();
      const { item } = e;
      const {graph} = this;
      const autoPaint = graph.get('autoPaint');
      graph.setAutoPaint(false);
      // 设置目标节点的 hover 状态 为 true
      graph.setItemState(item, 'hover', true);
      graph.paint();
      graph.setAutoPaint(autoPaint);
      const { size } = item.getModel();
      const offsetX = -size[0] / 2;
      const offsetY = -size[1] / 2;
      if (e.item._cfg.currentShape === 'cardAudit') {
        const cards = graph.getNodes().filter((n) => n._cfg.currentShape === 'cardAudit');
        if (cards.length < 2) {
          return;
        }
        this.createCloseBtn(item.getContainer(), {
          x: offsetX + size[0],
          y: offsetY
        });
      }
    },
    onNodeMouseleave(e) {
      // console.debug('onNodeMouseleave', e)
      e.preventDefault();
      const { item } = e;
      const {graph} = this;
      const autoPaint = graph.get('autoPaint');
      graph.setAutoPaint(false);
      graph.setItemState(item, 'hover', false);
      graph.paint();
      graph.setAutoPaint(autoPaint);
      // e.item.getModel().selected !== true
      if (e.item._cfg.currentShape === 'cardAudit') {
        this.deleteCloseBtn(item.getContainer());
      }
    },
    onRemoveMouseover(e) {
      const p = e.target.getParent();
      const icon = p.findById('remove-icon');
      const cs = e.item._cfg.styles.hover;
      icon && icon.attr({
        fill: cs.cFill
      });
    },
    onRemoveMouseout(e) {
      const p = e.target.getParent();
      const icon = p.findById('remove-icon');
      icon && icon.attr({
        fill: d9Color
      });
    },
    onAddMouseover(e) {
      const p = e.target.getParent();
      const bg = p.findById('add-bg');
      const icon = p.findById('add-icon');
      const arry = e.currentTarget.findAll('node', (n) => n.getModel().type === 'cardAudit');
      if (arry.length === 10) {
        e.target.attr({
          cursor: 'not-allowed'
        });
        bg.attr({
          stroke: cColor
        });
        const x = 45 * Math.PI / 180;
        icon.attr({
          stroke: cColor,
          path: crossPath,
          matrix: [Math.cos(x), Math.sin(-x), 0, Math.sin(x), Math.cos(x), 0, 0, 0, 1]
        });
        const matrix = p.getTotalMatrix();
        const bbox = p.getBBox();
        opts.tooltip.show({
          x: matrix[6] + bbox.width / 2,
          y: matrix[7],
          msg: opts.lang.pcRulesNodeMax(10),
          placement: 'right'
        });
      } else {
        bg.attr({
          fill: pColor
        });
        icon.attr({
          stroke: wColor,
          matrix: [1, 0, 0, 0, 1, 0, 0, 0, 1]
        });
      }
    },
    onAddMouseout(e) {
      const p = e.target.getParent();
      const bg = p.findById('add-bg');
      const icon = p.findById('add-icon');
      e.target.attr({
        cursor: 'pointer'
      });
      bg.attr({
        fill: wColor,
        stroke: pColor
      });
      icon.attr({
        stroke: pColor,
        path: addPath,
        matrix: [1, 0, 0, 0, 1, 0, 0, 0, 1]
      });
      opts.tooltip.hide();
    },
    onInputRadioClick(e) {
      e.stopPropagation();
      e.propagationStopped = true;
      const p = e.target.getParent();
      const { optType, auditPersType } = p.cfg;
      const { nodeId, options } = e.item.getModel();
      const sItem = options.find(it => it.value === auditPersType);
      if (!sItem) return;
      if (optType === 'openLayer') {
        e.currentTarget.emit('clickcheckboxopenlayer', {
          nodeId,
          ...sItem
        });
      } else {
        e.currentTarget.emit('menucheckboxchange', {
          nodeId,
          ...sItem
        });
      }
    },
    onInputRadioMouseover(e) {
      e.propagationStopped = true;
      const p = e.propagationPath.find(it => it.cfg.name === 'checkbox-radio');
      if (!p) return;
      const bg = p.findById('radio-bg');
      const { _attrs } = e.item._cfg.shapeFactory.shapeClass.options;
      bg && bg.attr({
        fill: _attrs.colors.pHover
      });
    },
    onInputRadioMouseout(e) {
      const p = e.propagationPath.find(it => it.cfg.name === 'checkbox-radio');
      if (!p) return;
      const bg = p.findById('radio-bg');
      bg && bg.attr({
        fill: wColor
      });
    },
    onHelpMouseover(e) {
      // e.propagationStopped = true
      e.defaultPrevented = true;
      const {graph} = this;
      const gHelp = e.target.getParent();
      const matrix = gHelp.getTotalMatrix();
      const bbox = gHelp.getBBox();
      const zoom = graph.getZoom();
      opts.tooltip.show({
        x: matrix[6] + bbox.maxX * zoom,
        y: matrix[7] + bbox.height / 2 * zoom,
        msg: e.target.attr('help'),
        placement: 'top'
      });
      const icon = gHelp.findById('help-icon');
      icon && icon.attr({ fill: _80Color });
    },
    onHelpMouseout(e) {
      opts.tooltip.hide();
      const gHelp = e.target.getParent();
      const icon = gHelp.findById('help-icon');
      icon && icon.attr({ fill: bColor });
    }
  });

  G6.registerLayout('bigraph-layout', {
    // 默认参数
    getDefaultCfg: function getDefaultCfg() {
      return {
        direction: 'vertical' // {vertical,horizontal} 两部分的分布方向
      };
    },
    // 执行布局
    execute: function execute() {
      const { nodes = [], nodeSep, direction } = this;
      // 放置节点
      let begin = 80;
      nodes.forEach((n, i) => {
        if (direction === 'vertical') {
          n.x = 0;
          n.y = begin;
          n.anchorPoints = [
            [0.5, 1],
            [0.5, 0]
          ];
          const next = nodes[i + 1];
          if (next) {
            begin += (next && next.size[1] || 0) + nodeSep;
          }
        }
      });
    },
    /**
     * 销毁
     */
    destroy() {
      this.positions = null;
      this.nodes = null;
      this.edges = null;
      this.destroyed = true;
    }
  });

  graph = new G6.Graph({
    ...opts,
    ...initAuditConfig
  });

  return graph;
}
